import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import './Job_cards.css'

import Pagination from "react-bootstrap/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSliders,
  faArrowLeft,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

import { Context } from "../../../utils/context";
import { jobData } from "../../../utils/apis/master/Master";
import Pagination_Holder from "../../common-section/Pagination_Holder/Pagination_Holder";




const Job_cards = () => {

  const { setJobId } = useContext(Context)
  const [onPageChange, setonPageChange] = useState(1);
  const [totalPages, settotalPages] = useState();
    const [currentPage, setcurrentPage] = useState();
  





  const jobdata = [
    {
      position: 'Functional Consultant',
      experience: '10-12',
      location: 'HYDERABAD'
    },
    {
      position: 'Sr. Software Engineer',
      experience: '10-12',
      location: 'PUNE'
    },
    {
      position: 'Tech Manager',
      experience: '10-12',
      location: 'HYDERABAD'
    },
    {
      position: 'Functional Consultant',
      experience: '10-12',
      location: 'HYDERABAD'
    },
    {
      position: 'Tech Manager',
      experience: '10-12',
      location: 'HYDERABAD'
    }
  ];

  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    console.log(section);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleNavigateAndScroll = (e, sectionId, jobId) => {
    console.log("handleNavigateAndScroll", e)
    e.preventDefault();
    setJobId(jobId)
    setExpanded(false); // Close the navbar
    navigate('/career');
    setTimeout(() => {
      scrollToSection(sectionId);
    }, 100); // Adjust the delay if necessary
  };

  const [data, setData] = useState([]);

  const getAllData = async () => {
    const res = await jobData(onPageChange);
    if (res?.success) {
      setData(res?.data);
      settotalPages(res?.data?.totalPages);
      setcurrentPage(res?.data?.currentPage)
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }


  useEffect(() => {

    getAllData(onPageChange)

  }, [onPageChange])



  useEffect(() => {
    getAllData();
  }, []);

  useEffect(() => {

    if (data?.data?.length > 0) {
      setJobId(data?.data?.[0]?.id)
    }

  }, [data])

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }


  return (
    <>
      <section className='job-card-sec mt-5'>
        <div className='container'>
          <div className='background-card'>
            <img className='curve-img' src={process.env.PUBLIC_URL + '/assets/images/about-us/banner/layer.png'} />
            <div className='subtt-div'>
              <h6 className='title'>Join our team to diverse talent and grow together</h6>
            </div>


            <div className='cardsec mt-5'>
              <div className='row'>
                <div className='col-md-11 mx-auto'>
                  <div className='row'>
                    {data?.data?.map((data, index) => (
                      <div className='col-lg-4 col-6 mb-md-4 mb-2'>
                        <div className='job-card'>
                          <h5 className='pos-name'>{data?.name}</h5>
                          <p className='exp'>Experience: {data?.experience?.name} Years</p>
                          <p className='exp'>Location: {data?.location}</p>
                          <button className='apply-btn' onClick={(e) => handleNavigateAndScroll(e, 'section1', data?.id)}>Apply</button>
                        </div>
                      </div>
                    ))}


                  </div>
                </div>
              </div>

              <div className="media-card-sec mt-5">

                <Pagination_Holder
                  onPageChange={currentPage}
                  totalPages={totalPages}
                  handlePageChange={handlePageChange}
                />


                {/* <Pagination className="justify-content-center">
                  <Pagination.Prev>
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      className="page-link-prev"
                    />
                  </Pagination.Prev>

                  {paginationItems}

                  <Pagination.Next>
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="page-link-next"
                    />
                  </Pagination.Next>
                </Pagination> */}



              </div>


            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Job_cards